export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'right',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'v_issueType',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_issueType') || '疵点问题类型',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'defectIssuesGroup',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_defectIssuesGroup') || '疵点问题组',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'defectIssuesTitle',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: that.$l('table_label_defectIssuesTitle') || '疵点问题标题',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: {default: 'status'},
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
